module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2z1"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/foreword#for"
    }
  }, [_vm._v("Translator’s Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#ch1"
    }
  }, [_vm._v("§1.   The first, most literal meaning of the word “logic”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#ch2"
    }
  }, [_vm._v("§2.   A first indication of the concept of the subject matter of “logic”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#ch3"
    }
  }, [_vm._v("§3.   A philosophizing logic and traditional scholastic logic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#ch4"
    }
  }, [_vm._v("§4.   The possibility and the being of truth in general. Skepticism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#ch5"
    }
  }, [_vm._v("§5.   Outline of the course. Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/parta#parta"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROLEGOMENON")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/partach1#partb"
    }
  }, [_vm._v("The contemporary situation of philosophical logic. (Psychologism and the question of truth)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/partach1#ch6"
    }
  }, [_vm._v("§6.   Psychologism: the name and the concept")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/partach1#ch7"
    }
  }, [_vm._v("§7.   Husserl’s critique of psychologism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/partach1#ch7lev1"
    }
  }, [_vm._v("a) Some preliminaries of the critique")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/partach1#ch7lev2"
    }
  }, [_vm._v("b) Demonstration of the fundamental errors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/partach1#ch8"
    }
  }, [_vm._v("§8.   The presuppositions of Husserl’s critique: a specific concept of truth as the guiding idea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/partach1#ch9"
    }
  }, [_vm._v("§9.   The roots of these presuppositions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/partach1#ch10"
    }
  }, [_vm._v("§10. Anti-critical questions. The need to take the question of the essence of truth back to Aristotle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/partach1#ch10lev1"
    }
  }, [_vm._v("a) Why must the critique of psychologism be a critique of psychology?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/partach1#ch10lev2"
    }
  }, [_vm._v("b) What positive contribution does the phenomenological investigation of psychologism make to the question of the concept and interpretation of the phenomenon of truth?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/partach1#ch10lev3"
    }
  }, [_vm._v("c) The connection between propositional and intuitional truth. The need to return to Aristotle")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part1#part1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" I.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part1ch1#part1a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The problem of truth in the decisive origins of philosophical logic, and the seedbed of traditional logic (focused on Aristotle)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part1ch1#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§11. The place of truth, and "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/c000v-01.jpg"
    }
  }), _vm._v(" (proposition)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part1ch1#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§12. The basic structure of "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/c000v-01.jpg"
    }
  }), _vm._v(" and the phenomenon of making sense")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part1ch1#ch12lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a) The as-structure of our primary way of understanding: the hermeneutical “as”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part1ch1#ch12lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b) The modification of the as-structure in the act of determining: the apophantic “as”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part1ch1#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§13. The conditions of the possibility of "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/c000v-01.jpg"
    }
  }), _vm._v(" being false. The question of truth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part1ch1#ch13lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a) Preparatory interpretation. "), _c('em', [_vm._v("Metaphysics")]), _vm._v(" IV 7 and VI 4, and "), _c('em', [_vm._v("De interpretatione")]), _vm._v(" 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part1ch1#ch13lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b) Truth and being. Interpretation of "), _c('em', [_vm._v("Metaphysics")]), _vm._v(" IX 10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part1ch1#ch13lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c) The three conditions for the possibility of a statement being false, taken in their interconnection")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part1ch1#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§14. The presupposition for Aristotle’s interpretation of truth as the authentic determination of being")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2#part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" II.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1#part2a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The radicalized question: What is truth? (A retrieval of the analysis of falsehood in terms of its ur-temporality)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§15. The idea of a phenomenological chronology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§16. The conditions of the possibility of falsehood within the horizon of the analysis of existence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§17. Care as the being of existence. Concern-for and concern-about, authenticity and inauthenticity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§18. The ur-temporality of care")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§19. Preparatory considerations toward attaining an original understanding of time. A return to the history of the philosophical interpretation of the concept of time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§20. Hegel’s interpretation of time in the "), _c('em', [_vm._v("Encyclopaedia")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§21. The influence of Aristotle on Hegel’s and Bergson’s interpretation of time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§22. A preliminary look at the meaning of time in Kant’s "), _c('em', [_vm._v("Critique of Pure Reason")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§23. The interpretation of time in the Transcendental Analytic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1#ch23lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a) An explanation of the notions “form” and “intuition”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1a#ch23lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b) The constitutive moments of ordering")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1a#ch23lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c) Form of intuition and formal intuition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1a#ch23lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d) Space and time as given infinite magnitudes; "), _c('em', [_vm._v("quantum")]), _vm._v(" and "), _c('em', [_vm._v("quantitas")]), _vm._v(" in Kant’s interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1a#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§24. The function of time in the Transcendental Logic. A characterization of the problematic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1a#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§25. The question of the unity of nature")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1a#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§26. The original "), _c('em', [_vm._v("a priori")]), _vm._v(" of all combining—the transcendental unity of apperception")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1a#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§27. Time as the universal "), _c('em', [_vm._v("a priori")]), _vm._v(" form of all appearances")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1b#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§28. Time as original pure self-affection")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1b#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§29. The question about the connection between time as original self-affection and the “I think”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1b#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§30. Interpretation of the First Analogy of Experience in the light of our interpretation of time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1b#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§31. The schematism of the pure concepts of the understanding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1b#ch31lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a) Sensibilization of appearances")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1b#ch31lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b) Sensibilization of empirical sensible concepts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1b#ch31lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c) Sensibilization of pure sensible concepts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1b#ch31lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d) Image and schema")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1b#ch31lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e) Sensibilization of the pure concepts of understanding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1b#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§32. Number as the schema of quantity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1b#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§33. Sensation as the schema of reality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1b#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§34. Persistence as the schema of substance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1b#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§35. The time-determination of the "), _c('em', [_vm._v("synthesis speciosa")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1b#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§36. The now-structure that we have attained: its character of referral and of making present. The phenomenal demonstrability and limits of Kant’s interpretation of time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2ch1b#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§37. Time as an existential of human existence—temporality and the structure of care. The statement as a making-present")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/afterword#aft",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Editor’s Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/glossary#glo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossaries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abbreviations")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0